<template>
<transition name="scale-up-center">
  <div id="CourseChatRoom">
    <div v-if="bcVisibility && bcContent" class="broadcast">
      <vui-ico class="ico ibang-notice broadcast-icon" :w="14" :h="14"></vui-ico>
      <div class="broadcast-content" v-html="formatedBcContent"></div>
      <vui-ico class="ico ibang-close broadcast-close" :w="14" :h="14" @click.native="closeBroadcast"></vui-ico>
    </div>
    <div class="msgs-and-members-container">
      <!-- 消息区 -->
      <VuiScroll
        v-show="nowTab === 'msgs'"
        class="msgs-container"
        ref="chatroom"
        :topLoad="scrollToTop"
        @contextmenu.native="onContextMenu"
        @mousedown.native="atControlStart"
        @mousemove.native="atControlMove"
        @mouseup.native="atControlEnd"
        @scrollEnd="onMsgsBoxScrollEnd"
      >
        <div
          v-for="v in displayedMsgs"
          :key="v.idClient"
          class="msg"
          :class="{ self: v.isSelf, atme: v.isAtMe }"
        >
          <template v-if="['text', 'custom.expression', 'custom.gift', 'image'].includes(v.type)">
            <Dropdown v-if="!v.isSelf">
              <a href="javascript:void(0)">
              <div
                class="avatar"
                :v-name="v.fromNick"
                :v-accid="v.from"
                :v-isSelf="v.isSelf"
                :style="{ backgroundImage: `url(${ v.fromAvatar || '/img/avatar-male.svg' })` }"
              ></div>
              </a>
            <Dropdown-menu slot="list" v-if="isManager">
                    <Dropdown-item @click.native="forbiddenUser(v)">禁言</Dropdown-item>
                </Dropdown-menu>
            </Dropdown>
            <div class="avatar"
                v-if="v.isSelf"
                :v-name="v.fromNick"
                :v-accid="v.from"
                :v-isSelf="v.isSelf"
                :style="{ backgroundImage: `url(${ v.fromAvatar || '/img/avatar-male.svg' })` }"
              ></div>
            <p class="username">
              <span>{{ `${v.fromNick}  ${v.timeString}` }}</span>
              <span v-if="v.role > 0"> · <span class="role">{{ v.role === 2 ? '老师' : '助教' }}</span></span>
            </p>

          </template>
          <div class="msg-box" style="display: inline-block">
            <!-- 文字 消息 -->
            <template v-if="v.type === 'text'">
              <p class="content" v-if="!v.tagMixed">{{v.text}}</p>
              <span class="content mixed-text" v-else v-html="v.tagResolvedMsg"></span>
            </template>
            <!-- 图片 消息 -->
            <template v-if="v.type === 'image'">
              <img width="150px" :src="v.file.url" @load="chatRoomScrollToBottom" @dblclick="preview(v.file.url)">
            </template>
            <!-- 自定义-表情 消息 -->
            <template v-if="v.type === 'custom.expression'">
              <img class="expression" :src="`/img/expression/${v.content.src}`">
            </template>
            <!-- 自定义-礼物 消息 -->
            <template v-if="v.type === 'custom.gift'">
              <p class="content gift-name">
                <span>{{ `送出了${v.content.name}` }}</span>
                <img class="gift" :src="`/img/gift/${v.content.src}`">
            </p>
            </template>
            <!-- 自己发送消息的状态 -->
            <template v-if="v.isSelf">
              <div class="send-status-wrap">
                <spinnerLoading v-if="v.sending"></spinnerLoading>
                <vui-ico
                  v-else-if="v.sendFailed"
                  class="send-failed-icon ibang-error"
                  :w="16"
                  @click.native="resendMsg(v)"
                ></vui-ico>
                <!-- <div class="send-failed-icon" v-else-if="v.sendFailed" @click="resendMsg(v)">!</div> -->
              </div>
              </template>
          </div>

        </div>
      </VuiScroll>
      <!-- 新消息提示 -->
      <div class="new-msg-prompt-btn" v-show="showNewMsgPromptBtn" @click="chatRoomScrollToBottom">
        <vui-ico
          class="btn-ico ibang-down"
          :w="16"
        ></vui-ico>
        <span>有新消息</span>
      </div>
      <!-- 右键弹出层 -->
      <VuiContextMenu
        v-model="showContextMenu"
        :top="contextMenuTop"
        :left="contextMenuLeft"
        :menu="[{ title: `@${contextMenuName}` }]"
        :callback="contextMenuCallback"
      ></VuiContextMenu>
    </div>
  </div>
</transition>
</template>

<script>
import spinnerLoading from '@/components/ui/spinnerLoading'
import ChatBus from '@/bus/chat'

export default {
  name: 'CourseChatRoom',
  components: {
    spinnerLoading,
  },
  props: {
    msgs: Array,
    members: Array,
    topLoad: Function,
    bottomLoad: Function,
    onlineMemberNum: Number,
    courseId: String,
    isManager: Boolean,
  },
  data () {
    return {
      nowTab: 'msgs', // ['msgs', 'members']
      atTimer: null, // @ 触发的定时器
      cx: -1,
      cy: -1,
      atControlEnded: false,
      // 右键弹出层相关
      showContextMenu: false,
      contextMenuName: '',
      contextMenuAccid: '',
      contextMenuLeft: 0,
      contextMenuTop: 0,
      // 需要展示的消息 全量消息的部分拷贝
      displayedMsgs: [],
      // 源消息数组截断点
      splitIndex: 0,
      // 滚动底部定时器
      scrollToBottomTimer: '',
      // 新消息提示
      showNewMsgPromptBtn: false,
      // 聊天列表是否在最底部
      isMsgListsOnBottom: true,

      bcVisibility: true,
      // 公告栏内容
      bcContent: '',
      formatedBcContent: '',
    }
  },
  watch: {
    msgs (arr, oldArr) {
      const el = this.$refs.chatroom.$el
      const elH = el.getBoundingClientRect().height
      const NEARHEIGHT = 20
      let onBottom = Math.abs(el.scrollTop + elH - el.scrollHeight) < NEARHEIGHT
      if (onBottom) {
        this.chatRoomScrollToBottom()
      }
      this.updateCurrentMsgLists(arr, onBottom)
    },
    nowTab (val) {
      ChatBus.$emit('changeTab', val)
    },
    '$store.state.chat.broadcast': {
      handler (after) {
        if (after.courseId === this.courseId) {
          this.bcVisibility = true
          this.bcContent = after.content
        }
      },
      deep: true,
    },
    bcContent (after) {
      this.formatedBcContent = this.formatBcContent(this.bcContent)
    },
  },
  methods: {
    forbiddenUser (v) {
      this.$emit('forbiddenUser', v)
    },
    onContextMenu (e) {
      const target = e.target

      const name = target.getAttribute('v-name')
      const accid = target.getAttribute('v-accid')
      const isSelf = target.getAttribute('v-isSelf')

      if (isSelf || !name) {
        return
      }

      e.preventDefault()

      const {
        clientX,
        clientY,
      } = e

      this.contextMenuName = name
      this.contextMenuAccid = accid
      this.contextMenuTop = clientY
      this.contextMenuLeft = clientX
      this.showContextMenu = true
    },
    contextMenuCallback () {
      this.showContextMenu = false
      ChatBus.$emit('setAt', {
        accid: this.contextMenuAccid,
        name: this.contextMenuName,
      })
      ChatBus.$emit('inputFocus')
    },
    // 头像 @ 控制器开始
    atControlStart (e) {
      const target = e.target

      const name = target.getAttribute('v-name')
      const accid = target.getAttribute('v-accid')
      const isSelf = target.getAttribute('v-isSelf')

      if (isSelf || !name) {
        return
      }

      e.preventDefault()

      this.cx = e.clientX || e.touches[0].clientX
      this.cy = e.clientY || e.touches[0].clientY

      const DELAY500 = 500
      this.atTimer = setTimeout(() => {
        this.atControlEnded = true
        ChatBus.$emit('setAt', {
          accid,
          name,
        })
      }, DELAY500)
    },
    // 头像 @ 控制器移动
    atControlMove (e) {
      const clientX = e.clientX || e.touches[0].clientX
      const clientY = e.clientY || e.touches[0].clientY

      const mx = Math.abs(this.cx - clientX)
      const my = Math.abs(this.cy - clientY)

      const NUMBER8 = 8
      if (mx > NUMBER8 || my > NUMBER8) {
        clearTimeout(this.atTimer)
      }
    },
    // 头像 @ 控制器结束
    atControlEnd (e) {
      clearTimeout(this.atTimer)

      if (this.atControlEnded) {
        ChatBus.$emit('inputFocus')
        this.atControlEnded = false
      }
    },
    // 聊天室滚动到最底部
    chatRoomScrollToBottom () {
      this.$nextTick(() => {
        if (this.$refs.chatroom) {
          const el = this.$refs.chatroom.$el
          el.scrollTop = el.scrollHeight
        }
      })
    },
    // 重新发送失败的消息
    resendMsg (msgData) {
      this.$emit('sendMsg', {
        msgData: msgData,
        resend: true,
      })
    },
    updateCurrentMsgLists (originalMsg, onBottom, recoverMsg) {
      if (recoverMsg) {
        let curFirstMsgEleCache = document.querySelectorAll('#CourseChatRoom .msg')[0]
        this.$nextTick(() => {
          curFirstMsgEleCache.scrollIntoViewIfNeeded && curFirstMsgEleCache.scrollIntoViewIfNeeded()
        })
      }
      this.displayedMsgs = this.getShouldDisplayMsgs(originalMsg, onBottom, recoverMsg)
    },
    /**
     * 获取当前应该展示的消息数组
     * originalMsg {Array} 全量消息数组
     * onBottom {Boolean} 滚动条是否在最底部
     * recoverMsg {Boolean} 是否需要恢复已移除的消息节点
     */
    getShouldDisplayMsgs (originalMsg, onBottom, recoverMsg) {
      const DISPLAYEDMSGLENGTH = 200
      let resultArray = []
      if (onBottom) {
        this.splitIndex = originalMsg.length - DISPLAYEDMSGLENGTH > 0
          ? originalMsg.length - DISPLAYEDMSGLENGTH
          : 0
        resultArray = originalMsg.slice(-DISPLAYEDMSGLENGTH)
      } else {
        if (recoverMsg) {
          this.splitIndex = this.splitIndex - DISPLAYEDMSGLENGTH > 0
            ? this.splitIndex - DISPLAYEDMSGLENGTH
            : 0
          resultArray = originalMsg.slice(this.splitIndex)
        } else {
          resultArray = originalMsg.slice(this.splitIndex - originalMsg.length)
        }
      }

      return resultArray
    },
    scrollToTop (dir) {
      if (this.splitIndex === 0) {
        return this.topLoad(dir)
      } else {
        return new Promise((resolve, reject) => {
          this.updateCurrentMsgLists(this.msgs, false, true)
          resolve()
        })
      }
    },
    onMsgsBoxScrollEnd (status) {
      let { onBottom } = status
      let MINUTEMILLISECONDS = 60000

      clearTimeout(this.scrollToBottomTimer)

      if (!onBottom) {
        this.isMsgListsOnBottom = false
        this.scrollToBottomTimer = setTimeout(() => {
          this.chatRoomScrollToBottom()
        }, MINUTEMILLISECONDS)
      } else {
        this.isMsgListsOnBottom = true
        this.showNewMsgPromptBtn = false
      }
    },
    closeBroadcast () {
      this.bcVisibility = false
    },
    // 处理公告中的换行
    formatBcContent (message = '') {
      return message.replace(/[\r\n]/g, '<br/>')
    },
    preview (url) {
      this.$emit('preview', url)
    },
  },
  mounted () {
    if (this.$store.state.chat.broadcast.courseId === this.courseId) {
      this.bcContent = this.$store.state.chat.broadcast.content
    }
    ChatBus.$on('showTabMsgs', () => {
      this.nowTab = 'msgs'
    })
    ChatBus.$on('sendNewMsg', () => {
      this.chatRoomScrollToBottom()
    })
    ChatBus.$on('receiveNewMsg', () => {
      this.showNewMsgPromptBtn = !this.isMsgListsOnBottom
    })
  },
}
</script>

<style lang="scss">
$tabs-height: 0;

#CourseChatRoom {
  background-color: #f0f0f0;
  overflow: scroll;
  position: relative;
  height: calc(100% - 44px);

  .broadcast {
    display: flex;
    justify-content: space-between;
    width: 100%;
    font-size: 14px;
    background: #fff9f4;
    padding: 10px;
    position: absolute;
    z-index: 1;
    .broadcast-icon {
      color: #fa8919;
    }
    .broadcast-content {
      line-height: 1.5;
      flex: 1;
      font-size: 12px;
      color: #5a5a5a;
      margin: 0 6px;
    }
  }

  .msgs-and-members-container {
    height: 100%;
  }

  .msgs-container,
  .members-container {
    @include wh(100%, 100%);
    overflow-x: hidden;
    overflow-y: auto;
    &::-webkit-scrollbar {
      display: none;
    }
  }

  .msgs-container {
    padding: 12px 10px 0;
  }

  .members-container {
    padding: 10px;

    .member-item {
      @include wh(100%, 40px);
      padding: 5px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }

    img {
      @include wh(30px, 30px);
      border-radius: 4px;
    }

    .name {
      @include font(14px, initial, #444);
      margin-left: 10px;
      flex-grow: 1;
      flex-shrink: 1;
    }

    .role {
      color: #ed6c00;
    }

    .time {
      @include font(12px, initial, #868688);
      margin-left: 10px;
    }
  }

  .msg {
    position: relative;
    padding: 6px 50px;
    text-align: left;
    white-space: pre-wrap;
    word-break: break-all;

    .msg-box {
      position: relative;
      bottom: 20px;
    }

    .avatar {
      @include wh(40px, 40px);
      @include pos(absolute, 10px, auto, auto, 0);
      border-radius: 4px;
      user-select: none;
      background-size: cover;
      background-position: center;
    }
    .ivu-dropdown{
      height:0px;
      padding-left:50px;
    }
    .ivu-dropdown-rel{
        position: static
    }
    .ivu-dropdown-item{
      text-align:center;
    }
    .username {
      @include font(12px, 17px, #8590a6);
      user-select: none;
      position: relative;
      bottom: 20px;
    }

    .role {
      color: #ed6c00;
    }

    .content {
      @include font(12px, 16px, #222);
      display: inline-block;
      padding: 8px;
      background-color: #ffffff;
      border-radius: 6px;
      display: inline-block;
      text-align: left;
      line-height: 20px;
    }

    .mixed-text {
      img {
        width: 20px;
        height:20px;
        vertical-align: text-bottom;
      }
    }

    .expression {
      @include wh(48px, 48px);
      user-select: none;
    }

    .gift-name {
      position: relative;
      padding-right: 36px;
    }

    .gift {
      @include wh(48px, 48px);
      @include pos(absolute, 50%, 0, auto, auto);
      transform: translate(50%, -50%);
      user-select: none;
    }

    .send-status-wrap {
      width: 30px;
      height: 30px;
      position: absolute;
      left: -40px;
      top: 50%;
      transform: translateY(-50%);

      .send-failed-icon {
        cursor: pointer;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        color: #ff1744;
        line-height: 18px;
        text-align: center;
      }
    }

    &.atme {
      .content {
        background-color: #fff9c4;
      }
    }

    &.self {
      text-align: right;

      .avatar {
        left: auto;
        right: 0;
        top: -10px !important;
      }

      .content {
        background-color: #e4eefc;
      }

      .gift-name {
        padding-right: 10px;
        padding-left: 30px;
      }

      .gift {
        left: 0;
        transform: translate(-50%, -50%);
      }
    }
  }

  a {
    color: #2d8cf0;
  }

  .new-msg-prompt-btn {
    width: 100px;
    height: 32px;
    box-sizing: border-box;
    border-radius: 16px;
    background-color: rgba(237, 108, 0, 0.8);
    position: absolute;
    bottom: 24px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    .btn-ico{
      color: #fcfcfc;
    }
    span {
      width: 48px;
      height: 16px;
      margin: left;
      font-size: 12px;
      font-weight: 500;
      text-align: center;
      color: #fcfcfc;
      line-height: 16px;
    }
  }
}
</style>
